import { PropsWithChildren, ReactElement, createElement } from "react";
import { Icon } from "./Icon";

const TagFromString = ({
  tag,
  ...props
}: PropsWithChildren & { tag: string } & { [key: string]: unknown }) => {
  return createElement(tag, props);
};

export const IconLabel = ({
  as = "p",
  icon,
  children,
}: PropsWithChildren & {
  as?: string;
  icon: string | ReactElement;
}): ReactElement => {
  return (
    <TagFromString
      tag={as}
      className="flex flex-row gap-x-2 items-center whitespace-nowrap"
    >
      {typeof icon === "string" ? <Icon src={icon} /> : icon}
      {children}
    </TagFromString>
  );
};
